var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-bar',{attrs:{"button-text":_vm.searchButtonText,"placeholder":_vm.placeholder,"store-class":_vm.storeClass,"initial-term":_vm.initialTerm},on:{"selected":_vm.selected},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"search-label"},[_vm._v(_vm._s(_vm.label))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }